import styled from 'styled-components/macro'

export const Container = styled.div`
  display: flex;
  flex: ${(props) => (props.$stationDetailsTab ? 1 : 'initial')};
  padding: ${(props) => (props.$stationDetailsTab ? '0' : '0 35px')};
  border-bottom: ${(props) =>
    props.$stationDetailsTab ? 'none' : '1px solid #d8d8d8'};
`
